export default {"src":"/_next/static/media/ellipsis-icon.c2e81411.svg","height":513,"width":513};